module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/numeric-0f43756639aca39ad6b4b3eef0f6d6d5.svg";